import { render } from "./Load.vue?vue&type=template&id=c9488a66"
import script from "./Load.vue?vue&type=script&lang=js"
export * from "./Load.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__